// @symbo.ls/collab-features/docs — governance docs + kb + notes.

import { getClient, PROJECT_GOVERNANCE } from '../../../governanceBridge.js'

export const DOCS_CONFIG = Object.freeze({
  projectName: PROJECT_GOVERNANCE,
  tables: {
    documents: 'documents',
    kb: 'kb_articles',
    notes: 'notes',
    links: 'links',
    resourceLinks: 'resource_links'
  }
})

const _sb = () => getClient(DOCS_CONFIG.projectName)
export const docsAvailable = () => !!_sb()

export const listDocuments = async ({ limit = 50 } = {}) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  return sb
    .from(DOCS_CONFIG.tables.documents)
    .select('*')
    .order('updated_at', { ascending: false })
    .limit(limit)
}

export const listKbArticles = async () => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  return sb.from(DOCS_CONFIG.tables.kb).select('*').order('created_at', { ascending: false })
}

export const getKbArticle = async (slug) => {
  const sb = _sb()
  if (!sb) return { data: null, error: null }
  return sb.from(DOCS_CONFIG.tables.kb).select('*').eq('slug', slug).maybeSingle()
}

export const upsertKbArticle = async (row) => {
  const sb = _sb()
  if (!sb) return { data: null, error: new Error('governance unavailable') }
  return sb.from(DOCS_CONFIG.tables.kb).upsert(row, { onConflict: 'slug' }).select('*').single()
}

export const listNotes = async ({ owner } = {}) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  let q = sb.from(DOCS_CONFIG.tables.notes).select('*').order('updated_at', { ascending: false })
  if (owner) q = q.eq('owner_email', owner)
  return q
}
